/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * AgencyOS API
 * API AgencyOS (/api/v1). Le client des apps est généré depuis ce schéma.
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  DocumentLayout,
  DocumentLayoutRequest,
  DocumentsFilesListParams,
  DocumentsLayoutsListParams,
  DocumentsLayoutsPreviewRetrieveParams,
  DocumentsNumberingListParams,
  DownloadLink,
  GeneratedDocument,
  LayoutPreview,
  NumberingSequence,
  NumberingSequenceRequest,
  PaginatedDocumentLayoutList,
  PaginatedGeneratedDocumentList,
  PaginatedNumberingSequenceList,
  PatchedNumberingSequenceRequest,
  SpecimenRequestRequest
} from '.././model';

import { apiFetch } from '../../http';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export type documentsFilesListResponse200 = {
  data: PaginatedGeneratedDocumentList
  status: 200
}
    
export type documentsFilesListResponseSuccess = (documentsFilesListResponse200) & {
  headers: Headers;
};
;

export type documentsFilesListResponse = (documentsFilesListResponseSuccess)

export const getDocumentsFilesListUrl = (params?: DocumentsFilesListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/documents/files/?${stringifiedParams}` : `/api/v1/documents/files/`
}

export const documentsFilesList = async (params?: DocumentsFilesListParams, options?: RequestInit): Promise<documentsFilesListResponse> => {
  
  return apiFetch<documentsFilesListResponse>(getDocumentsFilesListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getDocumentsFilesListQueryKey = (params?: DocumentsFilesListParams,) => {
    return [
    `/api/v1/documents/files/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getDocumentsFilesListQueryOptions = <TData = Awaited<ReturnType<typeof documentsFilesList>>, TError = unknown>(params?: DocumentsFilesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof documentsFilesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDocumentsFilesListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof documentsFilesList>>> = ({ signal }) => documentsFilesList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof documentsFilesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DocumentsFilesListQueryResult = NonNullable<Awaited<ReturnType<typeof documentsFilesList>>>
export type DocumentsFilesListQueryError = unknown


export function useDocumentsFilesList<TData = Awaited<ReturnType<typeof documentsFilesList>>, TError = unknown>(
 params: undefined |  DocumentsFilesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof documentsFilesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof documentsFilesList>>,
          TError,
          Awaited<ReturnType<typeof documentsFilesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDocumentsFilesList<TData = Awaited<ReturnType<typeof documentsFilesList>>, TError = unknown>(
 params?: DocumentsFilesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof documentsFilesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof documentsFilesList>>,
          TError,
          Awaited<ReturnType<typeof documentsFilesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDocumentsFilesList<TData = Awaited<ReturnType<typeof documentsFilesList>>, TError = unknown>(
 params?: DocumentsFilesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof documentsFilesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useDocumentsFilesList<TData = Awaited<ReturnType<typeof documentsFilesList>>, TError = unknown>(
 params?: DocumentsFilesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof documentsFilesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDocumentsFilesListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type documentsFilesRetrieveResponse200 = {
  data: GeneratedDocument
  status: 200
}
    
export type documentsFilesRetrieveResponseSuccess = (documentsFilesRetrieveResponse200) & {
  headers: Headers;
};
;

export type documentsFilesRetrieveResponse = (documentsFilesRetrieveResponseSuccess)

export const getDocumentsFilesRetrieveUrl = (id: string,) => {


  

  return `/api/v1/documents/files/${id}/`
}

export const documentsFilesRetrieve = async (id: string, options?: RequestInit): Promise<documentsFilesRetrieveResponse> => {
  
  return apiFetch<documentsFilesRetrieveResponse>(getDocumentsFilesRetrieveUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getDocumentsFilesRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/documents/files/${id}/`
    ] as const;
    }

    
export const getDocumentsFilesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof documentsFilesRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof documentsFilesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDocumentsFilesRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof documentsFilesRetrieve>>> = ({ signal }) => documentsFilesRetrieve(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof documentsFilesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DocumentsFilesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof documentsFilesRetrieve>>>
export type DocumentsFilesRetrieveQueryError = unknown


export function useDocumentsFilesRetrieve<TData = Awaited<ReturnType<typeof documentsFilesRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof documentsFilesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof documentsFilesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof documentsFilesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDocumentsFilesRetrieve<TData = Awaited<ReturnType<typeof documentsFilesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof documentsFilesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof documentsFilesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof documentsFilesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDocumentsFilesRetrieve<TData = Awaited<ReturnType<typeof documentsFilesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof documentsFilesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useDocumentsFilesRetrieve<TData = Awaited<ReturnType<typeof documentsFilesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof documentsFilesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDocumentsFilesRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Signed, time-limited download link (the file itself is never public).
 */
export type documentsFilesLinkRetrieveResponse200 = {
  data: DownloadLink
  status: 200
}
    
export type documentsFilesLinkRetrieveResponseSuccess = (documentsFilesLinkRetrieveResponse200) & {
  headers: Headers;
};
;

export type documentsFilesLinkRetrieveResponse = (documentsFilesLinkRetrieveResponseSuccess)

export const getDocumentsFilesLinkRetrieveUrl = (id: string,) => {


  

  return `/api/v1/documents/files/${id}/link/`
}

export const documentsFilesLinkRetrieve = async (id: string, options?: RequestInit): Promise<documentsFilesLinkRetrieveResponse> => {
  
  return apiFetch<documentsFilesLinkRetrieveResponse>(getDocumentsFilesLinkRetrieveUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getDocumentsFilesLinkRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/documents/files/${id}/link/`
    ] as const;
    }

    
export const getDocumentsFilesLinkRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof documentsFilesLinkRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof documentsFilesLinkRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDocumentsFilesLinkRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof documentsFilesLinkRetrieve>>> = ({ signal }) => documentsFilesLinkRetrieve(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof documentsFilesLinkRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DocumentsFilesLinkRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof documentsFilesLinkRetrieve>>>
export type DocumentsFilesLinkRetrieveQueryError = unknown


export function useDocumentsFilesLinkRetrieve<TData = Awaited<ReturnType<typeof documentsFilesLinkRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof documentsFilesLinkRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof documentsFilesLinkRetrieve>>,
          TError,
          Awaited<ReturnType<typeof documentsFilesLinkRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDocumentsFilesLinkRetrieve<TData = Awaited<ReturnType<typeof documentsFilesLinkRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof documentsFilesLinkRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof documentsFilesLinkRetrieve>>,
          TError,
          Awaited<ReturnType<typeof documentsFilesLinkRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDocumentsFilesLinkRetrieve<TData = Awaited<ReturnType<typeof documentsFilesLinkRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof documentsFilesLinkRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useDocumentsFilesLinkRetrieve<TData = Awaited<ReturnType<typeof documentsFilesLinkRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof documentsFilesLinkRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDocumentsFilesLinkRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * « Télécharger un PDF de test » (P1-01): printed in the background, no number used.
 */
export type documentsFilesSpecimenCreateResponse201 = {
  data: GeneratedDocument
  status: 201
}
    
export type documentsFilesSpecimenCreateResponseSuccess = (documentsFilesSpecimenCreateResponse201) & {
  headers: Headers;
};
;

export type documentsFilesSpecimenCreateResponse = (documentsFilesSpecimenCreateResponseSuccess)

export const getDocumentsFilesSpecimenCreateUrl = () => {


  

  return `/api/v1/documents/files/specimen/`
}

export const documentsFilesSpecimenCreate = async (specimenRequestRequest: SpecimenRequestRequest, options?: RequestInit): Promise<documentsFilesSpecimenCreateResponse> => {
  
  return apiFetch<documentsFilesSpecimenCreateResponse>(getDocumentsFilesSpecimenCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      specimenRequestRequest,)
  }
);}




export const getDocumentsFilesSpecimenCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof documentsFilesSpecimenCreate>>, TError,{data: SpecimenRequestRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof documentsFilesSpecimenCreate>>, TError,{data: SpecimenRequestRequest}, TContext> => {

const mutationKey = ['documentsFilesSpecimenCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof documentsFilesSpecimenCreate>>, {data: SpecimenRequestRequest}> = (props) => {
          const {data} = props ?? {};

          return  documentsFilesSpecimenCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DocumentsFilesSpecimenCreateMutationResult = NonNullable<Awaited<ReturnType<typeof documentsFilesSpecimenCreate>>>
    export type DocumentsFilesSpecimenCreateMutationBody = SpecimenRequestRequest
    export type DocumentsFilesSpecimenCreateMutationError = unknown

    export const useDocumentsFilesSpecimenCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof documentsFilesSpecimenCreate>>, TError,{data: SpecimenRequestRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof documentsFilesSpecimenCreate>>,
        TError,
        {data: SpecimenRequestRequest},
        TContext
      > => {

      const mutationOptions = getDocumentsFilesSpecimenCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Versions are never edited: POST creates the next version and makes it current.
 */
export type documentsLayoutsListResponse200 = {
  data: PaginatedDocumentLayoutList
  status: 200
}
    
export type documentsLayoutsListResponseSuccess = (documentsLayoutsListResponse200) & {
  headers: Headers;
};
;

export type documentsLayoutsListResponse = (documentsLayoutsListResponseSuccess)

export const getDocumentsLayoutsListUrl = (params?: DocumentsLayoutsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/documents/layouts/?${stringifiedParams}` : `/api/v1/documents/layouts/`
}

export const documentsLayoutsList = async (params?: DocumentsLayoutsListParams, options?: RequestInit): Promise<documentsLayoutsListResponse> => {
  
  return apiFetch<documentsLayoutsListResponse>(getDocumentsLayoutsListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getDocumentsLayoutsListQueryKey = (params?: DocumentsLayoutsListParams,) => {
    return [
    `/api/v1/documents/layouts/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getDocumentsLayoutsListQueryOptions = <TData = Awaited<ReturnType<typeof documentsLayoutsList>>, TError = unknown>(params?: DocumentsLayoutsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof documentsLayoutsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDocumentsLayoutsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof documentsLayoutsList>>> = ({ signal }) => documentsLayoutsList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof documentsLayoutsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DocumentsLayoutsListQueryResult = NonNullable<Awaited<ReturnType<typeof documentsLayoutsList>>>
export type DocumentsLayoutsListQueryError = unknown


export function useDocumentsLayoutsList<TData = Awaited<ReturnType<typeof documentsLayoutsList>>, TError = unknown>(
 params: undefined |  DocumentsLayoutsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof documentsLayoutsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof documentsLayoutsList>>,
          TError,
          Awaited<ReturnType<typeof documentsLayoutsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDocumentsLayoutsList<TData = Awaited<ReturnType<typeof documentsLayoutsList>>, TError = unknown>(
 params?: DocumentsLayoutsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof documentsLayoutsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof documentsLayoutsList>>,
          TError,
          Awaited<ReturnType<typeof documentsLayoutsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDocumentsLayoutsList<TData = Awaited<ReturnType<typeof documentsLayoutsList>>, TError = unknown>(
 params?: DocumentsLayoutsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof documentsLayoutsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useDocumentsLayoutsList<TData = Awaited<ReturnType<typeof documentsLayoutsList>>, TError = unknown>(
 params?: DocumentsLayoutsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof documentsLayoutsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDocumentsLayoutsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Versions are never edited: POST creates the next version and makes it current.
 */
export type documentsLayoutsCreateResponse201 = {
  data: DocumentLayout
  status: 201
}
    
export type documentsLayoutsCreateResponseSuccess = (documentsLayoutsCreateResponse201) & {
  headers: Headers;
};
;

export type documentsLayoutsCreateResponse = (documentsLayoutsCreateResponseSuccess)

export const getDocumentsLayoutsCreateUrl = () => {


  

  return `/api/v1/documents/layouts/`
}

export const documentsLayoutsCreate = async (documentLayoutRequest: DocumentLayoutRequest, options?: RequestInit): Promise<documentsLayoutsCreateResponse> => {
  
  return apiFetch<documentsLayoutsCreateResponse>(getDocumentsLayoutsCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      documentLayoutRequest,)
  }
);}




export const getDocumentsLayoutsCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof documentsLayoutsCreate>>, TError,{data: DocumentLayoutRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof documentsLayoutsCreate>>, TError,{data: DocumentLayoutRequest}, TContext> => {

const mutationKey = ['documentsLayoutsCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof documentsLayoutsCreate>>, {data: DocumentLayoutRequest}> = (props) => {
          const {data} = props ?? {};

          return  documentsLayoutsCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DocumentsLayoutsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof documentsLayoutsCreate>>>
    export type DocumentsLayoutsCreateMutationBody = DocumentLayoutRequest
    export type DocumentsLayoutsCreateMutationError = unknown

    export const useDocumentsLayoutsCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof documentsLayoutsCreate>>, TError,{data: DocumentLayoutRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof documentsLayoutsCreate>>,
        TError,
        {data: DocumentLayoutRequest},
        TContext
      > => {

      const mutationOptions = getDocumentsLayoutsCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Versions are never edited: POST creates the next version and makes it current.
 */
export type documentsLayoutsRetrieveResponse200 = {
  data: DocumentLayout
  status: 200
}
    
export type documentsLayoutsRetrieveResponseSuccess = (documentsLayoutsRetrieveResponse200) & {
  headers: Headers;
};
;

export type documentsLayoutsRetrieveResponse = (documentsLayoutsRetrieveResponseSuccess)

export const getDocumentsLayoutsRetrieveUrl = (id: string,) => {


  

  return `/api/v1/documents/layouts/${id}/`
}

export const documentsLayoutsRetrieve = async (id: string, options?: RequestInit): Promise<documentsLayoutsRetrieveResponse> => {
  
  return apiFetch<documentsLayoutsRetrieveResponse>(getDocumentsLayoutsRetrieveUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getDocumentsLayoutsRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/documents/layouts/${id}/`
    ] as const;
    }

    
export const getDocumentsLayoutsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof documentsLayoutsRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof documentsLayoutsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDocumentsLayoutsRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof documentsLayoutsRetrieve>>> = ({ signal }) => documentsLayoutsRetrieve(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof documentsLayoutsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DocumentsLayoutsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof documentsLayoutsRetrieve>>>
export type DocumentsLayoutsRetrieveQueryError = unknown


export function useDocumentsLayoutsRetrieve<TData = Awaited<ReturnType<typeof documentsLayoutsRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof documentsLayoutsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof documentsLayoutsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof documentsLayoutsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDocumentsLayoutsRetrieve<TData = Awaited<ReturnType<typeof documentsLayoutsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof documentsLayoutsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof documentsLayoutsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof documentsLayoutsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDocumentsLayoutsRetrieve<TData = Awaited<ReturnType<typeof documentsLayoutsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof documentsLayoutsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useDocumentsLayoutsRetrieve<TData = Awaited<ReturnType<typeof documentsLayoutsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof documentsLayoutsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDocumentsLayoutsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Publish an old version again (as a new version: history is kept).
 */
export type documentsLayoutsRestoreCreateResponse200 = {
  data: DocumentLayout
  status: 200
}
    
export type documentsLayoutsRestoreCreateResponseSuccess = (documentsLayoutsRestoreCreateResponse200) & {
  headers: Headers;
};
;

export type documentsLayoutsRestoreCreateResponse = (documentsLayoutsRestoreCreateResponseSuccess)

export const getDocumentsLayoutsRestoreCreateUrl = (id: string,) => {


  

  return `/api/v1/documents/layouts/${id}/restore/`
}

export const documentsLayoutsRestoreCreate = async (id: string, options?: RequestInit): Promise<documentsLayoutsRestoreCreateResponse> => {
  
  return apiFetch<documentsLayoutsRestoreCreateResponse>(getDocumentsLayoutsRestoreCreateUrl(id),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getDocumentsLayoutsRestoreCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof documentsLayoutsRestoreCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof documentsLayoutsRestoreCreate>>, TError,{id: string}, TContext> => {

const mutationKey = ['documentsLayoutsRestoreCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof documentsLayoutsRestoreCreate>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  documentsLayoutsRestoreCreate(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DocumentsLayoutsRestoreCreateMutationResult = NonNullable<Awaited<ReturnType<typeof documentsLayoutsRestoreCreate>>>
    
    export type DocumentsLayoutsRestoreCreateMutationError = unknown

    export const useDocumentsLayoutsRestoreCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof documentsLayoutsRestoreCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof documentsLayoutsRestoreCreate>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDocumentsLayoutsRestoreCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Versions are never edited: POST creates the next version and makes it current.
 */
export type documentsLayoutsCurrentRetrieveResponse200 = {
  data: DocumentLayout
  status: 200
}
    
export type documentsLayoutsCurrentRetrieveResponseSuccess = (documentsLayoutsCurrentRetrieveResponse200) & {
  headers: Headers;
};
;

export type documentsLayoutsCurrentRetrieveResponse = (documentsLayoutsCurrentRetrieveResponseSuccess)

export const getDocumentsLayoutsCurrentRetrieveUrl = () => {


  

  return `/api/v1/documents/layouts/current/`
}

export const documentsLayoutsCurrentRetrieve = async ( options?: RequestInit): Promise<documentsLayoutsCurrentRetrieveResponse> => {
  
  return apiFetch<documentsLayoutsCurrentRetrieveResponse>(getDocumentsLayoutsCurrentRetrieveUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getDocumentsLayoutsCurrentRetrieveQueryKey = () => {
    return [
    `/api/v1/documents/layouts/current/`
    ] as const;
    }

    
export const getDocumentsLayoutsCurrentRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof documentsLayoutsCurrentRetrieve>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof documentsLayoutsCurrentRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDocumentsLayoutsCurrentRetrieveQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof documentsLayoutsCurrentRetrieve>>> = ({ signal }) => documentsLayoutsCurrentRetrieve({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof documentsLayoutsCurrentRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DocumentsLayoutsCurrentRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof documentsLayoutsCurrentRetrieve>>>
export type DocumentsLayoutsCurrentRetrieveQueryError = unknown


export function useDocumentsLayoutsCurrentRetrieve<TData = Awaited<ReturnType<typeof documentsLayoutsCurrentRetrieve>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof documentsLayoutsCurrentRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof documentsLayoutsCurrentRetrieve>>,
          TError,
          Awaited<ReturnType<typeof documentsLayoutsCurrentRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDocumentsLayoutsCurrentRetrieve<TData = Awaited<ReturnType<typeof documentsLayoutsCurrentRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof documentsLayoutsCurrentRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof documentsLayoutsCurrentRetrieve>>,
          TError,
          Awaited<ReturnType<typeof documentsLayoutsCurrentRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDocumentsLayoutsCurrentRetrieve<TData = Awaited<ReturnType<typeof documentsLayoutsCurrentRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof documentsLayoutsCurrentRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useDocumentsLayoutsCurrentRetrieve<TData = Awaited<ReturnType<typeof documentsLayoutsCurrentRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof documentsLayoutsCurrentRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDocumentsLayoutsCurrentRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * HTML preview of the current layout, with the agency's data of right now.
 */
export type documentsLayoutsPreviewRetrieveResponse200 = {
  data: LayoutPreview
  status: 200
}
    
export type documentsLayoutsPreviewRetrieveResponseSuccess = (documentsLayoutsPreviewRetrieveResponse200) & {
  headers: Headers;
};
;

export type documentsLayoutsPreviewRetrieveResponse = (documentsLayoutsPreviewRetrieveResponseSuccess)

export const getDocumentsLayoutsPreviewRetrieveUrl = (params?: DocumentsLayoutsPreviewRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/documents/layouts/preview/?${stringifiedParams}` : `/api/v1/documents/layouts/preview/`
}

export const documentsLayoutsPreviewRetrieve = async (params?: DocumentsLayoutsPreviewRetrieveParams, options?: RequestInit): Promise<documentsLayoutsPreviewRetrieveResponse> => {
  
  return apiFetch<documentsLayoutsPreviewRetrieveResponse>(getDocumentsLayoutsPreviewRetrieveUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getDocumentsLayoutsPreviewRetrieveQueryKey = (params?: DocumentsLayoutsPreviewRetrieveParams,) => {
    return [
    `/api/v1/documents/layouts/preview/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getDocumentsLayoutsPreviewRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof documentsLayoutsPreviewRetrieve>>, TError = unknown>(params?: DocumentsLayoutsPreviewRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof documentsLayoutsPreviewRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDocumentsLayoutsPreviewRetrieveQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof documentsLayoutsPreviewRetrieve>>> = ({ signal }) => documentsLayoutsPreviewRetrieve(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof documentsLayoutsPreviewRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DocumentsLayoutsPreviewRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof documentsLayoutsPreviewRetrieve>>>
export type DocumentsLayoutsPreviewRetrieveQueryError = unknown


export function useDocumentsLayoutsPreviewRetrieve<TData = Awaited<ReturnType<typeof documentsLayoutsPreviewRetrieve>>, TError = unknown>(
 params: undefined |  DocumentsLayoutsPreviewRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof documentsLayoutsPreviewRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof documentsLayoutsPreviewRetrieve>>,
          TError,
          Awaited<ReturnType<typeof documentsLayoutsPreviewRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDocumentsLayoutsPreviewRetrieve<TData = Awaited<ReturnType<typeof documentsLayoutsPreviewRetrieve>>, TError = unknown>(
 params?: DocumentsLayoutsPreviewRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof documentsLayoutsPreviewRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof documentsLayoutsPreviewRetrieve>>,
          TError,
          Awaited<ReturnType<typeof documentsLayoutsPreviewRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDocumentsLayoutsPreviewRetrieve<TData = Awaited<ReturnType<typeof documentsLayoutsPreviewRetrieve>>, TError = unknown>(
 params?: DocumentsLayoutsPreviewRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof documentsLayoutsPreviewRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useDocumentsLayoutsPreviewRetrieve<TData = Awaited<ReturnType<typeof documentsLayoutsPreviewRetrieve>>, TError = unknown>(
 params?: DocumentsLayoutsPreviewRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof documentsLayoutsPreviewRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDocumentsLayoutsPreviewRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type documentsNumberingListResponse200 = {
  data: PaginatedNumberingSequenceList
  status: 200
}
    
export type documentsNumberingListResponseSuccess = (documentsNumberingListResponse200) & {
  headers: Headers;
};
;

export type documentsNumberingListResponse = (documentsNumberingListResponseSuccess)

export const getDocumentsNumberingListUrl = (params?: DocumentsNumberingListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/documents/numbering/?${stringifiedParams}` : `/api/v1/documents/numbering/`
}

export const documentsNumberingList = async (params?: DocumentsNumberingListParams, options?: RequestInit): Promise<documentsNumberingListResponse> => {
  
  return apiFetch<documentsNumberingListResponse>(getDocumentsNumberingListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getDocumentsNumberingListQueryKey = (params?: DocumentsNumberingListParams,) => {
    return [
    `/api/v1/documents/numbering/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getDocumentsNumberingListQueryOptions = <TData = Awaited<ReturnType<typeof documentsNumberingList>>, TError = unknown>(params?: DocumentsNumberingListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof documentsNumberingList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDocumentsNumberingListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof documentsNumberingList>>> = ({ signal }) => documentsNumberingList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof documentsNumberingList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DocumentsNumberingListQueryResult = NonNullable<Awaited<ReturnType<typeof documentsNumberingList>>>
export type DocumentsNumberingListQueryError = unknown


export function useDocumentsNumberingList<TData = Awaited<ReturnType<typeof documentsNumberingList>>, TError = unknown>(
 params: undefined |  DocumentsNumberingListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof documentsNumberingList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof documentsNumberingList>>,
          TError,
          Awaited<ReturnType<typeof documentsNumberingList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDocumentsNumberingList<TData = Awaited<ReturnType<typeof documentsNumberingList>>, TError = unknown>(
 params?: DocumentsNumberingListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof documentsNumberingList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof documentsNumberingList>>,
          TError,
          Awaited<ReturnType<typeof documentsNumberingList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDocumentsNumberingList<TData = Awaited<ReturnType<typeof documentsNumberingList>>, TError = unknown>(
 params?: DocumentsNumberingListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof documentsNumberingList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useDocumentsNumberingList<TData = Awaited<ReturnType<typeof documentsNumberingList>>, TError = unknown>(
 params?: DocumentsNumberingListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof documentsNumberingList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDocumentsNumberingListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type documentsNumberingCreateResponse201 = {
  data: NumberingSequence
  status: 201
}
    
export type documentsNumberingCreateResponseSuccess = (documentsNumberingCreateResponse201) & {
  headers: Headers;
};
;

export type documentsNumberingCreateResponse = (documentsNumberingCreateResponseSuccess)

export const getDocumentsNumberingCreateUrl = () => {


  

  return `/api/v1/documents/numbering/`
}

export const documentsNumberingCreate = async (numberingSequenceRequest: NumberingSequenceRequest, options?: RequestInit): Promise<documentsNumberingCreateResponse> => {
  
  return apiFetch<documentsNumberingCreateResponse>(getDocumentsNumberingCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      numberingSequenceRequest,)
  }
);}




export const getDocumentsNumberingCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof documentsNumberingCreate>>, TError,{data: NumberingSequenceRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof documentsNumberingCreate>>, TError,{data: NumberingSequenceRequest}, TContext> => {

const mutationKey = ['documentsNumberingCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof documentsNumberingCreate>>, {data: NumberingSequenceRequest}> = (props) => {
          const {data} = props ?? {};

          return  documentsNumberingCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DocumentsNumberingCreateMutationResult = NonNullable<Awaited<ReturnType<typeof documentsNumberingCreate>>>
    export type DocumentsNumberingCreateMutationBody = NumberingSequenceRequest
    export type DocumentsNumberingCreateMutationError = unknown

    export const useDocumentsNumberingCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof documentsNumberingCreate>>, TError,{data: NumberingSequenceRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof documentsNumberingCreate>>,
        TError,
        {data: NumberingSequenceRequest},
        TContext
      > => {

      const mutationOptions = getDocumentsNumberingCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type documentsNumberingRetrieveResponse200 = {
  data: NumberingSequence
  status: 200
}
    
export type documentsNumberingRetrieveResponseSuccess = (documentsNumberingRetrieveResponse200) & {
  headers: Headers;
};
;

export type documentsNumberingRetrieveResponse = (documentsNumberingRetrieveResponseSuccess)

export const getDocumentsNumberingRetrieveUrl = (id: string,) => {


  

  return `/api/v1/documents/numbering/${id}/`
}

export const documentsNumberingRetrieve = async (id: string, options?: RequestInit): Promise<documentsNumberingRetrieveResponse> => {
  
  return apiFetch<documentsNumberingRetrieveResponse>(getDocumentsNumberingRetrieveUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getDocumentsNumberingRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/documents/numbering/${id}/`
    ] as const;
    }

    
export const getDocumentsNumberingRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof documentsNumberingRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof documentsNumberingRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDocumentsNumberingRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof documentsNumberingRetrieve>>> = ({ signal }) => documentsNumberingRetrieve(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof documentsNumberingRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type DocumentsNumberingRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof documentsNumberingRetrieve>>>
export type DocumentsNumberingRetrieveQueryError = unknown


export function useDocumentsNumberingRetrieve<TData = Awaited<ReturnType<typeof documentsNumberingRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof documentsNumberingRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof documentsNumberingRetrieve>>,
          TError,
          Awaited<ReturnType<typeof documentsNumberingRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDocumentsNumberingRetrieve<TData = Awaited<ReturnType<typeof documentsNumberingRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof documentsNumberingRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof documentsNumberingRetrieve>>,
          TError,
          Awaited<ReturnType<typeof documentsNumberingRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useDocumentsNumberingRetrieve<TData = Awaited<ReturnType<typeof documentsNumberingRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof documentsNumberingRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useDocumentsNumberingRetrieve<TData = Awaited<ReturnType<typeof documentsNumberingRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof documentsNumberingRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDocumentsNumberingRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type documentsNumberingUpdateResponse200 = {
  data: NumberingSequence
  status: 200
}
    
export type documentsNumberingUpdateResponseSuccess = (documentsNumberingUpdateResponse200) & {
  headers: Headers;
};
;

export type documentsNumberingUpdateResponse = (documentsNumberingUpdateResponseSuccess)

export const getDocumentsNumberingUpdateUrl = (id: string,) => {


  

  return `/api/v1/documents/numbering/${id}/`
}

export const documentsNumberingUpdate = async (id: string,
    numberingSequenceRequest: NumberingSequenceRequest, options?: RequestInit): Promise<documentsNumberingUpdateResponse> => {
  
  return apiFetch<documentsNumberingUpdateResponse>(getDocumentsNumberingUpdateUrl(id),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      numberingSequenceRequest,)
  }
);}




export const getDocumentsNumberingUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof documentsNumberingUpdate>>, TError,{id: string;data: NumberingSequenceRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof documentsNumberingUpdate>>, TError,{id: string;data: NumberingSequenceRequest}, TContext> => {

const mutationKey = ['documentsNumberingUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof documentsNumberingUpdate>>, {id: string;data: NumberingSequenceRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  documentsNumberingUpdate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DocumentsNumberingUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof documentsNumberingUpdate>>>
    export type DocumentsNumberingUpdateMutationBody = NumberingSequenceRequest
    export type DocumentsNumberingUpdateMutationError = unknown

    export const useDocumentsNumberingUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof documentsNumberingUpdate>>, TError,{id: string;data: NumberingSequenceRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof documentsNumberingUpdate>>,
        TError,
        {id: string;data: NumberingSequenceRequest},
        TContext
      > => {

      const mutationOptions = getDocumentsNumberingUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type documentsNumberingPartialUpdateResponse200 = {
  data: NumberingSequence
  status: 200
}
    
export type documentsNumberingPartialUpdateResponseSuccess = (documentsNumberingPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type documentsNumberingPartialUpdateResponse = (documentsNumberingPartialUpdateResponseSuccess)

export const getDocumentsNumberingPartialUpdateUrl = (id: string,) => {


  

  return `/api/v1/documents/numbering/${id}/`
}

export const documentsNumberingPartialUpdate = async (id: string,
    patchedNumberingSequenceRequest: PatchedNumberingSequenceRequest, options?: RequestInit): Promise<documentsNumberingPartialUpdateResponse> => {
  
  return apiFetch<documentsNumberingPartialUpdateResponse>(getDocumentsNumberingPartialUpdateUrl(id),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      patchedNumberingSequenceRequest,)
  }
);}




export const getDocumentsNumberingPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof documentsNumberingPartialUpdate>>, TError,{id: string;data: PatchedNumberingSequenceRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof documentsNumberingPartialUpdate>>, TError,{id: string;data: PatchedNumberingSequenceRequest}, TContext> => {

const mutationKey = ['documentsNumberingPartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof documentsNumberingPartialUpdate>>, {id: string;data: PatchedNumberingSequenceRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  documentsNumberingPartialUpdate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DocumentsNumberingPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof documentsNumberingPartialUpdate>>>
    export type DocumentsNumberingPartialUpdateMutationBody = PatchedNumberingSequenceRequest
    export type DocumentsNumberingPartialUpdateMutationError = unknown

    export const useDocumentsNumberingPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof documentsNumberingPartialUpdate>>, TError,{id: string;data: PatchedNumberingSequenceRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof documentsNumberingPartialUpdate>>,
        TError,
        {id: string;data: PatchedNumberingSequenceRequest},
        TContext
      > => {

      const mutationOptions = getDocumentsNumberingPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type documentsNumberingDestroyResponse204 = {
  data: void
  status: 204
}
    
export type documentsNumberingDestroyResponseSuccess = (documentsNumberingDestroyResponse204) & {
  headers: Headers;
};
;

export type documentsNumberingDestroyResponse = (documentsNumberingDestroyResponseSuccess)

export const getDocumentsNumberingDestroyUrl = (id: string,) => {


  

  return `/api/v1/documents/numbering/${id}/`
}

export const documentsNumberingDestroy = async (id: string, options?: RequestInit): Promise<documentsNumberingDestroyResponse> => {
  
  return apiFetch<documentsNumberingDestroyResponse>(getDocumentsNumberingDestroyUrl(id),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}




export const getDocumentsNumberingDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof documentsNumberingDestroy>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof documentsNumberingDestroy>>, TError,{id: string}, TContext> => {

const mutationKey = ['documentsNumberingDestroy'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof documentsNumberingDestroy>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  documentsNumberingDestroy(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DocumentsNumberingDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof documentsNumberingDestroy>>>
    
    export type DocumentsNumberingDestroyMutationError = unknown

    export const useDocumentsNumberingDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof documentsNumberingDestroy>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof documentsNumberingDestroy>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDocumentsNumberingDestroyMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    